import { ReactNode } from "react"
import { QueryClient, QueryClientProvider } from "react-query"

interface Props {
  children: ReactNode
}

const client = new QueryClient()

export function ReactQueryProvider({ children }: Props) {
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>
}
